const binding = { modules: {}, dataActions: {} };

    const registerActionId = (actionPath) => {
        if (binding.dataActions[actionPath] &&
            binding.dataActions[actionPath].default &&
            binding.dataActions[actionPath].default.prototype &&
            binding.dataActions[actionPath].default.prototype.id) {
            binding.dataActions[binding.dataActions[actionPath].default.prototype.id] = binding.dataActions[actionPath];
        } else {
            Object.keys(binding.dataActions[actionPath] || {}).forEach(exportName => {
                if (binding.dataActions[actionPath][exportName] &&
                    binding.dataActions[actionPath][exportName].prototype &&
                    binding.dataActions[actionPath][exportName].prototype.Action) {
                    binding.dataActions[binding.dataActions[actionPath][exportName].prototype.id] = binding.dataActions[actionPath][exportName];
                }
            })
        }
    };

    const registerSanitizedActionPath = (sanitizedActionPath, dataAction) => {
        if (process.env.NODE_ENV === 'development') {
            if (!dataAction.default) {
                throw new Error('Data action path does not have a default export');
            }
            if (!(dataAction.default.prototype.id && binding.dataActions[dataAction.default.prototype.id]) || !binding.dataActions[sanitizedActionPath]) {
                binding.dataActions[sanitizedActionPath] = dataAction;
            }
        } else {
            binding.dataActions[sanitizedActionPath] = dataAction;
            if (!binding.dataActions[sanitizedActionPath].default) {
                throw new Error('Data action path ' + sanitizedActionPath + ' does not have a default export');
            }
            binding.dataActions[sanitizedActionPath].default.prototype.RegistrationId = sanitizedActionPath;
            if (binding.dataActions[sanitizedActionPath].default.prototype.id) {
                binding.dataActions[binding.dataActions[sanitizedActionPath].default.prototype.id] = sanitizedActionPath;
            }
        }
    };
    

    (binding.modules['mfrm-products-compare'] = {
        c: () => require('partner/modules/mfrm-products-compare/mfrm-products-compare.tsx'),
        $type: 'containerModule',
        da: [{name:'comfortTypesData',  path:'data-actions/get-comfort-type.action', runOn: 0},{name:'product',  path:'@msdyn365-commerce-modules/retail-actions/dist/lib/get-selected-variant', runOn: 0},{name:'productBenefitsData',  path:'data-actions/get-product-benefits-data.action', runOn: 0},{name:'productCompareBuyboxStateSharing',  path:'actions/product-compare-buybox-state-sharing', runOn: 0},{name:'productsCompareIds',  path:'actions/fetch-choose-your-foundation-database.action', runOn: 0},{name:'unbxdCollectionCompare',  path:'modules/mfrm-products-compare/get-unbxd-collection-compare-data.action', runOn: 0}],
        
        iNM: false,
        ns: '__local__',
        n: 'mfrm-products-compare',
        p: '__local__',
        
        pdp: '',
        
        
        md: 'src/modules/mfrm-products-compare'
    });
        

        {
            const sanitizedActionPath = '@msdyn365-commerce-modules/retail-actions/dist/lib/get-selected-variant';
            let dataAction = require('@msdyn365-commerce-modules/retail-actions/dist/lib/get-selected-variant');
            registerSanitizedActionPath(sanitizedActionPath, dataAction);
        }
            

        {
            const sanitizedActionPath = 'actions/fetch-choose-your-foundation-database.action';
            let dataAction = require('partner/actions/fetch-choose-your-foundation-database.action');
            registerSanitizedActionPath(sanitizedActionPath, dataAction);
        }
            

        {
            const sanitizedActionPath = 'actions/product-compare-buybox-state-sharing';
            let dataAction = require('partner/actions/product-compare-buybox-state-sharing');
            registerSanitizedActionPath(sanitizedActionPath, dataAction);
        }
            

        {
            const sanitizedActionPath = 'data-actions/get-comfort-type.action';
            let dataAction = require('partner/data-actions/get-comfort-type.action');
            registerSanitizedActionPath(sanitizedActionPath, dataAction);
        }
            

        {
            const sanitizedActionPath = 'data-actions/get-product-benefits-data.action';
            let dataAction = require('partner/data-actions/get-product-benefits-data.action');
            registerSanitizedActionPath(sanitizedActionPath, dataAction);
        }
            

        {
            const sanitizedActionPath = 'modules/mfrm-products-compare/get-unbxd-collection-compare-data.action';
            let dataAction = require('partner/modules/mfrm-products-compare/get-unbxd-collection-compare-data.action');
            registerSanitizedActionPath(sanitizedActionPath, dataAction);
        }
            

        
    window.__bindings__ = window.__bindings__ || {};
    window.__bindings__.modules = {
        ...window.__bindings__.modules || {},
        ...binding.modules
    };
    
        window.__bindings__.dataActions = {
        ...window.__bindings__.dataActions || {},
        ...binding.dataActions
    };
                        export const viewDictionary = {};
                        viewDictionary['__local__|__local__|modules|mfrm-products-compare|mfrm-products-compare'] = {
                c: () => require('partner/modules/mfrm-products-compare/mfrm-products-compare.view.tsx'),
                cn: '__local__-__local__-mfrm-products-compare'
            };
window.__bindings__ = window.__bindings__ || {};
window.__bindings__.viewDictionary = {
                        ...window.__bindings__.viewDictionary || {},
                        ...viewDictionary
                    };